export const appReducers = {
  LOADING_START: (state) => {
    state.loading = true;
  },
  LOADING_END: (state) => {
    state.loading = false;
  },
  BACKDROP_SHOW: (state) => {
    state.backdrop = true;
  },
  BACKDROP_HIDE: (state) => {
    state.backdrop = false;
  },
  OPEN_MODAL: (state, action) => {
    state.modal = {
      modalState: true,
      modalContent: action.payload.content,
      modalTitle: action.payload.title,
      modalOnClose: action.payload.onClose,
      modalColor: action.payload.modalColor,
    };
  },
  CLOSE_MODAL: (state) => {
    state.modal = { modalState: false, modalContent: null, modalTitle: null };
  },
  DRAWER: (state, action) => {
    state.drawer = {
      ...state.drawer,
      ...action.payload,
    };
  },

  RESET_TIME_TO_LOGOUT: (state) => {
    state.inActiveTime = 1800;
  },
  SET_SHOW_POULTRIES: (state) => {
    state.showPoultries = !state.showPoultries;
    // Update activeLayer based on which layers are currently shown
    if (state.showPoultries || state.showStewards || state.showLiveStocks || state.showInspections) {
      // Keep the first active layer, or set to the most recently toggled one
      if (state.showPoultries && !state.activeLayer) {
        state.activeLayer = "poultries";
      }
    } else {
      state.activeLayer = null;
    }
  },
  SET_SHOW_STEWARDS: (state) => {
    state.showStewards = !state.showStewards;
    // Update activeLayer based on which layers are currently shown
    if (state.showPoultries || state.showStewards || state.showLiveStocks || state.showInspections) {
      // Keep the first active layer, or set to the most recently toggled one
      if (state.showStewards && !state.activeLayer) {
        state.activeLayer = "stewards";
      }
    } else {
      state.activeLayer = null;
    }
  },
  SET_SHOW_LiveStocks: (state) => {
    state.showLiveStocks = !state.showLiveStocks;
    // Update activeLayer based on which layers are currently shown
    if (state.showPoultries || state.showStewards || state.showLiveStocks || state.showInspections) {
      // Keep the first active layer, or set to the most recently toggled one
      if (state.showLiveStocks && !state.activeLayer) {
        state.activeLayer = "livestocks";
      }
    } else {
      state.activeLayer = null;
    }
  },
  SET_SHOW_INSPECTIONS: (state) => {
    state.showInspections = !state.showInspections;
    // Update activeLayer based on which layers are currently shown
    if (state.showPoultries || state.showStewards || state.showLiveStocks || state.showInspections) {
      // Keep the first active layer, or set to the most recently toggled one
      if (state.showInspections && !state.activeLayer) {
        state.activeLayer = "inspections";
      }
    } else {
      state.activeLayer = null;
    }
  },
  SET_ACTIVE_LAYER: (state, action) => {
    const target = action.payload;
    state.showStewards = target === "stewards";
    state.showPoultries = target === "poultries";
    state.showLiveStocks = target === "livestocks";
    state.showInspections = target === "inspections";
    state.activeLayer = target ?? null;
  },

  SET_MAP_VIEW: (state, action) => {
    state.mapAttribution = action.payload.mapAttribution;
    state.mapUrl = action.payload.mapUrl;
    state.mapViewIndex = action.payload.mapViewIndex;
  },

  SET_SEARCH_MARKER: (state, action) => {
    state.searchMarker = action.payload;
  },
};
